// Entry point for the build script in your package.json

import 'htmx.org';

import './components/navigation-bar.js';
import './components/curriculum-selector.js';
import './components/player.js';
import './components/area-card.js';

import './pages/standard.js';
import './pages/search.js';

// Setup

window.htmx = require('htmx.org');
